import {z} from 'zod'

import {CreateOrUpdateBlockKpiDocument} from '@sdox/api'

import {KpiRowForm} from '../../SharedForms/Kpi/KpiRowForm'
import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {kpiFormSchema} from '../../utils/schemas'
import {kpiFormValueToKpiInput} from '../../utils/kpiFormValueToKpiInput'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockKpiInput, CreateOrUpdateBlockKpiMutation, XcNwBlock_KpiTypeBlockRowType_Fragment} from '@sdox/api'

type UpdateKpisValidatorSchema = z.infer<typeof updateKpisValidatorSchema>

const updateKpisValidatorSchema = z.object({
  data: z.array(kpiFormSchema),
  meta: updateMetaSchema,
})

export const kpiConfig = createFormConfig<
  UpdateKpisValidatorSchema,
  CreateOrUpdateBlockKpiMutation,
  BlockKpiInput[],
  XcNwBlock_KpiTypeBlockRowType_Fragment
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockKpiDocument,
  },
  validatorSchema: updateKpisValidatorSchema,
  fieldMapper: (fieldValues) => {
    if (!Array.isArray(fieldValues.data)) {
      throw new Error('kpi fieldValues must have a data array')
    }
    return fieldValues.data.map(kpiFormValueToKpiInput)
  },
  customFormNode: <KpiRowForm />,
  getDefaultValues: (block) => ({
    data: block.items.map((current) => {
      if (current.__typename === 'KpiNumberType') {
        return {
          title: current.title,
          value: current.numberValue,
          prefix: current.prefix,
          suffix: current.suffix,
          subtitle: current.subtitle,
          variant: current.kpiVariant === null ? 'none' : current.kpiVariant,
        }
      }
      if (current.__typename === 'KpiTextType') {
        return {
          title: current.title,
          value: current.stringValue,
          prefix: current.prefix ?? current.prefix,
          suffix: current.suffix ?? current.suffix,
          subtitle: current.subtitle ?? current.subtitle,
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const exhaustiveCheck: never = current
      return {}
    }, {}),
  }),
})
